declare namespace $ {

	export class $mol_icon_notebook extends $mol_icon {
		path( ): string
	}
	
}

//# sourceMappingURL=notebook.view.tree.d.ts.map